import { __assign, __rest } from "tslib";
import React from 'react';
var VeltMultiThreadCommentDialogMinimalActionsDropdownTriggerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-actions-dropdown-trigger-wireframe", __assign({}, remainingProps), children));
};
export default VeltMultiThreadCommentDialogMinimalActionsDropdownTriggerWireframe;
